import React, { useState, useEffect, useRef } from "react";
import { CSVLink } from "react-csv";
import { KeyboardDatePicker } from "@material-ui/pickers";

import MakeAPICall from "../../apiCalls/common";

import {
  getPharmacyDetailApiRoute,
  getRecentPrescriptionsApiRoute,
  uploadPharmacyDataApiRoute
} from "../../apiRoutes";
import { sortData, csUndefined } from "../../utils/commonMethods";
import {
  getFormattedDate,
  getFormattedTime,
  converToUtc
} from "../../utils/dateTimeHelper";

import Button from "../../components/button";
import CustomModal from "../../components/modal";
import Loader from "../../components/loader";
import ICPhoneDisplay from "../../components/phoneDisplay";
import CustomDataTable from "../../components/datatable/customDataTable";

import UploadPharmaciesForm from "../../containers/UploadPharmaciesForm";

const PharmaciesPage = () => {
  const csvDownRef = useRef(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [pharmaciesList, setPharmaciesList] = useState([]);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [showPharmacyModal, setShowPharmacyModal] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currFilters, setCurrFilters] = useState({
    skip: 0,
    limit: 10
  });
  const [showTextModal, setShowTextModal] = useState(false);
  const [modalText, setModalText] = useState("");

  const tableHeaders = [
    {
      key: "PharmacyName",
      value: "Pharmacy Name"
    },
    { key: "PharmacyAddress", value: "Pharmacy Email" },
    { key: "PharmacyPhoneNumber", value: "Pharmacy Phone Number" },
    { key: "PharmacyEmailAddress", value: "Pharmacy Address" }
  ];

  let excelSheetHeader = [
    { label: "Date", key: "Date" },
    { label: "Pharmacy Selected Date", key: "pharmacySelectedDate" },
    { label: "Time", key: "Time" },
    { label: "Script ID", key: "Script_ID" },
    { label: "Paper or Electronic", key: "Paper_or_Electronic" },
    { label: "Global Unique Identifier", key: "Global_Unique_Identifier" },
    { label: "Print Code", key: "printHardCopyURL" },
    { label: "Doctor UIN", key: "Doctor_UIN" },
    { label: "Doctor Name", key: "Doctor_Name" },
    { label: "Patient UIN", key: "Patient_UIN" },
    { label: "Patient Name", key: "Patient_Name" },
    { label: "Pharmacy Name", key: "Pharmacy_Name" },
    { label: "Pharmacy Address Line 1", key: "Pharmacy_Address_Line_1" },
    { label: "Pharmacy Address Line 2", key: "Pharmacy_Address_Line_2" },
    { label: "Suburb", key: "Suburb" },
    { label: "State", key: "State" },
    { label: "Postcode", key: "Postcode" },
    { label: "Pharmacy Phone Number", key: "Pharmacy_Phone_Number" },
    { label: "Pharmacy Email Address", key: "Pharmacy_Email_Address" },
    { label: "Drug Name", key: "Drug_Name" },
    { label: "Strength", key: "Strength" },
    { label: "Form Type", key: "Form_Type" },
    { label: "Dosing Amount", key: "Dosing_Amount" },
    { label: "Frequency", key: "Frequency" },
    { label: "Quantity", key: "Quantity" },
    { label: "No of Repeats", key: "No_of_Repeats" },
    // { label: "Minimum Repeats Interval", key: "Minimum_Repeats_Interval" },
    { label: "Cancelled", key: "Cancelled" },
    { label: "Ceased Repeats", key: "Ceased_Repeats" }
  ];

  const toggleModal = () => {
    setShowPharmacyModal(!showPharmacyModal);
  };

  const setTableFilters = filters => {
    let newFilter = Object.assign({}, currFilters);
    newFilter.limit = filters.limit;
    newFilter.skip = filters.skip;
    newFilter.text = filters.text;
    setCurrFilters(newFilter);
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(
      SelColumn.column,
      SelColumn.order,
      pharmaciesList
    );
    setPharmaciesList(sortedData);
  };

  // get pharmacies list
  const getPharmaciesList = () => {
    setIsProcessing(true);

    setApiCallParams({
      reqType: "GET",
      reqUrl: getPharmacyDetailApiRoute,
      params: currFilters,
      successCallback: async res => {
        let list = [];
        await res.data.data.getDetailsUsingZip.forEach(item => {
          let tem = item;
          tem.PharmacyAddress = item.PharmacyAddress1;
          if (item.PharmacyAddress2 && item.PharmacyAddress2 !== "") {
            tem.PharmacyAddress =
              tem.PharmacyAddress + " " + item.PharmacyAddress2;
          }
          if (item.Suburb && item.Suburb !== "") {
            tem.PharmacyAddress = tem.PharmacyAddress + " " + item.Suburb;
          }
          if (item.State && item.State !== "") {
            tem.PharmacyAddress = tem.PharmacyAddress + " " + item.State;
          }
          if (item.Postcode && item.Postcode !== "") {
            tem.PharmacyAddress = tem.PharmacyAddress + " " + item.Postcode;
          }

          list.push(tem);
        });
        setPharmaciesList(list);
        setTotalRecords(res.data.data.getCount);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // get recent prescription list
  const getRecentPrescription = () => {
    setIsProcessing(true);

    var formData = {};

    if (startDate !== null && endDate !== null && startDate <= endDate) {
      let dt = new Date(
        endDate.get("year"),
        endDate.get("month"),
        endDate.get("date") + 1,
        0,
        0,
        0
      ).toISOString();
    
      formData = {
        startDate: converToUtc(startDate),
        endDate: converToUtc(dt)
      };
    }
    setApiCallParams({
      reqType: "GET",
      reqUrl: getRecentPrescriptionsApiRoute,
      params: formData,
      successCallback: async res => {
        let list = [];
        await res.data.data.forEach(columns => {
          var e = {};

          if (columns.patientData && columns.data && columns.doctorData) {
            e.Date = getFormattedDate(columns.createdAt);
            e.Time = getFormattedTime(columns.createdAt);
            e.Script_ID = columns.data.scriptNumber;
            e.Paper_or_Electronic =
              columns.data.prescriptionState === 2 ? "Electronic" : "Paper";
            e.Global_Unique_Identifier = columns.data.erxSCID;

            // when admin generates the hard copy prescription then we will have a PDF url and we need to show the last degit or print code. We are extracting "printhardcopy.....XXXX.pdf"
            e.printHardCopyURL = '';
            if (columns.printHardCopyURL) {
              e.printHardCopyURL = columns.printHardCopyURL.split('/').pop().split('.')[0]
            }

            e.Doctor_UIN = columns.doctorData.doctorId;
            e.Doctor_Name =
              columns.doctorData.firstName.trim() +
              " " +
              columns.doctorData.lastName.trim();
            e.Patient_UIN = columns.patientData.patientId;
            e.Patient_Name =
              columns.patientData.firstName.trim() +
              " " +
              columns.patientData.lastName.trim();

            if (columns.data.isPatient) {
              e.Pharmacy_Name = "N/A";
              e.Pharmacy_Address_Line_1 = "N/A";
              e.Pharmacy_Address_Line_2 = "N/A";
              e.Suburb = "N/A";
              e.State = "N/A";
              e.Postcode = "N/A";
              e.Pharmacy_Phone_Number = "N/A";
              e.Pharmacy_Email_Address = "N/A";
            } else {
              e.Pharmacy_Name = columns.data.pharmacyName
                ? columns.data.pharmacyName
                : "";
              e.Pharmacy_Address_Line_1 = columns.data.pharmacyAddress1
                ? csUndefined(columns.data.pharmacyAddress1)
                : "";
              e.Pharmacy_Address_Line_2 = columns.data.pharmacyAddress2
                ? csUndefined(columns.data.pharmacyAddress2)
                : "";
              e.Suburb = columns.pharmacyDetail.Suburb;
              e.State = columns.pharmacyDetail.State;
              e.Postcode = columns.pharmacyDetail.Postcode;
              e.Pharmacy_Phone_Number = columns.data.pharmacyNumber;
              e.Pharmacy_Email_Address = columns.data.pharmacyEmail;
            }

            e.Drug_Name = columns.data.drugName;
            e.Strength = columns.data.strength;
            e.Form_Type = columns.data.formType;
            e.Dosing_Amount = columns.data.dose;
            e.Frequency = columns.data.frequency;
            e.Quantity = columns.data.medQuanity;
            e.No_of_Repeats = columns.data.Repeats;
            // e.Minimum_Repeats_Interval = columns.data.miniIntervalRepeats;
            e.Cancelled = columns.data.isPrescriptionCancelled ? "YES" : "";
            e.Ceased_Repeats = columns.data.isEPrescribingCeased ? "YES" : "";

            e.pharmacySelectedDate = columns.data.pharmacySelected && columns.data.pharmacySelected.pharmacySelectedAt ? getFormattedDate(columns.data.pharmacySelected.pharmacySelectedAt) : '';

            list.push(e);
          }
        });
        setExcelSheetData(list);
        setIsProcessing(false);

        // after setting the excel sheet data trigger the csv download component click event
        csvDownRef.current.link.click();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // upload pharmacies list
  const uploadPharmaciesList = file => {
    setShowPharmacyModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("csvFile", file);

    setApiCallParams({
      reqType: "POST",
      reqUrl: uploadPharmacyDataApiRoute,
      dataObj: formData,
      successCallback: res => {
        setIsProcessing(false);

        let re = res.data;

        if (re.statusCode === 200) {
          setModalText("Pharmacies List Uploaded Successfully");

          getPharmaciesList();
        }

        if (re.statusCode === 403) {
          setModalText(
            "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
          );
        }

        setModalText(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setModalText(true);
      }
    });
  };

  useEffect(() => {
    getPharmaciesList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  const handleStartDateChange = date => {
    setStartDate(date);
  };
  
  const handleEndDateChange = date => {
    setEndDate(date);
  };
  
  const clearFilter = () => {
    setStartDate(null);
    setEndDate(null);
  };

  return (
    <div className="view-ticket-container">
      <CustomModal
        openModal={showPharmacyModal}
        cancelEvent={toggleModal}
        title="Upload Pharmacy CSV"
        modalBodyContent={
          <UploadPharmaciesForm onSheetSubmit={uploadPharmaciesList} />
        }
        noFooterButtons={true}
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showTextModal}
        cancelEvent={() => {
          setShowTextModal(false);
          setModalText("");
        }}
        modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
      />
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="d-flex flex-row flex-wrap justify-content-between">
          <h3>Pharmacies</h3>
          <div className="d-flex flex-row align-items-end">
             <KeyboardDatePicker
              name="startDate"
              style={{ width: "135px" }}
              autoOk
              variant="inline"
              mask="__-__-____"
              format="DD-MM-YYYY"
              label="Start Date"
              value={startDate}
              onChange={date => handleStartDateChange(date)}
            />
            <KeyboardDatePicker
              name="endDate"
              style={{ width: "135px", marginLeft: "20px" }}
              autoOk
              variant="inline"
              mask="__-__-____"
              format="DD-MM-YYYY"
              label="End Date"
              value={endDate}
              onChange={date => handleEndDateChange(date)}
            />
            {startDate !== null && endDate !== null && (
              <button
                style={{ minWidth: "30px", width: "30px" }}
                className="insta-button-primary ic-btn-red ml-3"
                onClick={clearFilter}
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            )}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <CSVLink
              style={{ display: "none" }}
              ref={csvDownRef}
              className="no-text-decoration"
              filename={"Recent_Prescriptions.csv"}
              data={excelSheetData}
              headers={excelSheetHeader}
            ></CSVLink>
            <Button
              clickEvent={getRecentPrescription}
              title="Recent Prescriptions"
            ></Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a
              className="insta-button-primary"
              href="https://www.instantconsult.com.au/PharmacyFinder/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Pharmacy Finder
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button
              clickEvent={toggleModal}
              title="Upload Pharmacy CSV"
            ></Button>
          </div>
        </div>
        <CustomDataTable
          totalRecords={totalRecords}
          headers={tableHeaders}
          setFilters={setTableFilters}
          sortData={sortTableDataByColumn}
          tabFilters={currFilters}
        >
          {pharmaciesList.map((item, index) => (
            <tr key={index}>
              <td>{item.PharmacyName}</td>
              <td>{item.PharmacyEmailAddress}</td>
              <td>
                <ICPhoneDisplay
                  mask="99 9999 9999"
                  value={item.PharmacyPhoneNumber}
                />
              </td>
              <td>{item.PharmacyAddress}</td>
            </tr>
          ))}
        </CustomDataTable>
        {/* API Call */}
        <MakeAPICall apiParam={apiCallParams} />
      </div>
    </div>
  );
};

export default PharmaciesPage;
